import styled, { css } from 'styled-components'

const Shape1Wrapper = styled.div<{ rotate?: string }>`
  z-index: 0;
  width: 100%;
  height: 100%;
  ${({ rotate }) =>
    rotate &&
    css`
      transform: rotate(${rotate});
    `}

  .yellow {
    width: 12%;
    height: 12%;
    transform: rotate(-330deg);
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.secondary};
    position: absolute;
    bottom: 14%;
    left: 21%;
  }

  .orange {
    width: 65%;
    height: 65%;
    transform: rotate(-330deg);
    border-radius: 9px;
    background-color: ${({ theme }) => theme.colors.pumpkinOrange};
    position: absolute;
    right: 10%;
    top: 10%;
  }

  .blue {
    width: 20%;
    height: 20%;
    transform: rotate(-330deg);
    border-radius: 5px;
    background-color: ${({ theme }) => theme.colors.primary};
    position: absolute;
    bottom: 12%;
    right: 36%;
  }
`

export const ProfileBackgroundShape = () => (
  <Shape1Wrapper>
    <div className="yellow" />
    <div className="orange" />
    <div className="blue" />
  </Shape1Wrapper>
)

export const ProfileBackgroundShape2 = () => (
  <Shape1Wrapper rotate="270deg">
    <div className="yellow" />
    <div className="orange" />
    <div className="blue" />
  </Shape1Wrapper>
)
